var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCallReceive(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 18 18",
    style: {
      enableBackground: "new 0 0 18 18"
    },
    xmlSpace: "preserve",
    className: "call-receive-icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#04B543;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2.1,1.3C1.7,1.7,1.3,2.1,0.9,2.5C0,3.4-0.2,4.7,0.4,5.8c1.3,2.6,3,4.9,5.1,7c2,1.9,4.2,3.5,6.6,4.8 c1.2,0.6,2.6,0.4,3.5-0.6l1.1-1.1l0.6-0.6l0.4-0.4l0.1-0.1l0,0l-4.9-4.9l-0.7,0.7L11.9,11l0,0c-0.2,0.2-0.4,0.4-0.6,0.6 c-0.1,0.1-0.1,0.1-0.2,0c-2-1.2-3.6-2.8-4.8-4.8c-0.1-0.1-0.1-0.2,0-0.2C6.6,6.3,7,5.9,7.3,5.6l0.7-0.7L3.3,0.1L2.1,1.3L2.1,1.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallReceive);
export default __webpack_public_path__ + "static/media/call-Receive.3c5e65f20478f6f6f9692c0c6e5a975b.svg";
export { ForwardRef as ReactComponent };